var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSponsored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 43H27C22.3406 43 20.0109 43 18.1732 43.7612C15.7229 44.7761 13.7762 46.7229 12.7612 49.173C12 51.011 12 53.3405 12 58C12 62.6595 12 64.989 12.7612 66.827C13.7762 69.277 15.7229 71.224 18.1732 72.239C20.0109 73 22.3406 73 27 73H32L72.398 85.1195C77.1455 86.5435 79.5195 87.256 81.6285 88.507L81.7295 88.5675C83.8315 89.8315 85.5835 91.5835 89.0885 95.0885L89.929 95.929C90.5255 96.5255 90.8235 96.8235 91.155 97.0615C91.7805 97.5105 92.5015 97.8095 93.2615 97.934C93.6635 98 94.0855 98 94.929 98C96.8565 98 97.8205 98 98.598 97.7375C100.077 97.2385 101.239 96.0775 101.738 94.598C102 93.8205 102 92.8565 102 90.929V25.071C102 23.1433 102 22.1794 101.738 21.4019C101.239 19.9226 100.077 18.7613 98.598 18.2623C97.8205 18 96.8565 18 94.929 18C94.0855 18 93.6635 18 93.2615 18.066C92.5015 18.1907 91.7805 18.4893 91.155 18.9385C90.8235 19.1763 90.5255 19.4745 89.929 20.071L89.0885 20.9115C85.5835 24.4163 83.8315 26.1687 81.7295 27.4324L81.6285 27.4928C79.5195 28.7442 77.1455 29.4563 72.398 30.8805L32 43Z",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0002 43.0004V73.0004V43.0004Z",
    fill: "rgba(var(--secondaryColorRGB),0.2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0002 43.0004V73.0004",
    stroke: "var(--secondaryColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9999 75.4996V88.2286C36.9999 93.6251 41.3744 97.9996 46.7707 97.9996C50.0374 97.9996 53.0884 96.3671 54.9004 93.6486L61.9999 82.9996",
    fill: "rgba(var(--secondaryColorRGB),0.2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9999 75.4996V88.2286C36.9999 93.6251 41.3744 97.9996 46.7707 97.9996C50.0374 97.9996 53.0884 96.3671 54.9004 93.6486L61.9999 82.9996",
    stroke: "var(--secondaryColor)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsored);
export default __webpack_public_path__ + "static/media/sponsored.b371cca122d0b231afc60dd47f9977af.svg";
export { ForwardRef as ReactComponent };